import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../supabaseClient';
import { useAuth } from '../contexts/AuthContext';

export default function TrashPage() {
  const { membership } = useAuth();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!membership?.org_id) return;
    setLoading(true);
    const { data } = await supabase
      .schema('workspace')
      .from('pages')
      .select('id, title, icon, type, updated_at')
      .eq('org_id', membership.org_id)
      .eq('archived', true)
      .order('updated_at', { ascending: false });
    setRows(data || []);
    setLoading(false);
  }, [membership?.org_id]);

  useEffect(() => { load(); }, [load]);

  async function restore(id) {
    await supabase.schema('workspace').from('pages').update({ archived: false }).eq('id', id);
    load();
  }
  async function remove(id) {
    if (!window.confirm('영구 삭제할까요? 되돌릴 수 없습니다.')) return;
    await supabase.schema('workspace').from('pages').delete().eq('id', id);
    load();
  }

  return (
    <div className="page-narrow tp-root" style={{ maxWidth: 680, margin: '0 auto', padding: '40px 24px' }}>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 4 }}>🗑️ 휴지통</h1>
      <div className="muted" style={{ marginBottom: 16 }}>삭제한 페이지를 복원하거나 영구 삭제합니다.</div>
      {loading && <div className="muted">불러오는 중…</div>}
      {!loading && rows.length === 0 && <div className="muted">휴지통이 비어 있습니다.</div>}
      {rows.map((p) => (
        <div key={p.id} className="tp-row" style={{ display: 'flex', gap: 10, alignItems: 'center', padding: '10px 8px', borderBottom: '1px solid var(--line)' }}>
          <span className="tp-row-icon">{p.icon || (p.type === 'database' ? '🗂️' : '📄')}</span>
          <span className="tp-row-title" style={{ flex: 1, fontWeight: 500 }}>{p.title || '제목 없음'}</span>
          <button className="btn ghost sm tp-row-btn" onClick={() => restore(p.id)} style={{ width: 'auto', padding: '5px 10px', margin: 0 }}>복원</button>
          <button className="btn ghost sm tp-row-btn" onClick={() => remove(p.id)} style={{ width: 'auto', padding: '5px 10px', margin: 0, color: 'var(--red)' }}>영구 삭제</button>
        </div>
      ))}
    </div>
  );
}
